import { USERS_ICON_CLASS_MAP, USERS_TYPES_ORDER } from '../types';
import { renderAsCellLabel, riskManagementEntitiesRenderer, selectColumnRenderer } from '../../common/customRenderers';
import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';
import { ActionsColumnValues, State } from '../../common/constants';
import { translateFn } from '../../../utils/translator.helper';
import { RiskManagementSideMenuEvents } from '../../sideMenus/common/common';

export function userBehaviorRiskRenderer(rowData) {
  return renderAsCellLabel(
    Application.modules.riskManagement.controller.helpers.routinesTranslations.translateRoutineName(
      rowData?.item?.indicatorId,
      true
    )
  );
}

export function affectedUsersRenderer(rowData) {
  return riskManagementEntitiesRenderer.call(
    this,
    rowData?.item,
    rowData?.item?.affectedUsers,
    USERS_TYPES_ORDER,
    USERS_ICON_CLASS_MAP,
    BaseWebComponentTranslator.getInstance().getRiskManagementUserType
  );
}

export function actionsColumnRenderer(rowData) {
  if (!rowData.item.company.specifics.features.iorUsable) {
    return selectColumnRenderer.call(this, rowData, []);
  }

  const options = [] as Array<any>;

  if (rowData.item.state === State.IGNORED) {
    options.push({
      title: translateFn('Restore ignored risk'),
      value: ActionsColumnValues.RESTORE,
      event: {
        name: RiskManagementSideMenuEvents.RESTORE_HUMAN_RISKS,
        detail: {
          indicatorsIds: [rowData.item.indicatorId],
          companyId: rowData.item.company._id,
        },
      },
    });
  } else {
    options.push({
      title: translateFn('Ignore risk'),
      value: ActionsColumnValues.IGNORE,
      event: {
        name: RiskManagementSideMenuEvents.IGNORE_HUMAN_RISKS,
        detail: {
          indicatorsIds: [rowData.item.indicatorId],
          companyId: rowData.item.company._id,
        },
      },
    });
  }

  return selectColumnRenderer.call(this, rowData, options);
}
